







import { Component, Prop, Vue } from "vue-property-decorator";
import { Style } from "@/services/styles/types";

@Component
export default class DateStyle extends Vue {
    @Prop() private itemStyle!: Style;

    get model(): DateStyle {
        return this.itemStyle.css
            ? (this.itemStyle.css as DateStyle)
            : ({} as DateStyle);
    }
}
